import { toJpeg } from 'html-to-image'

/**
 * Export Chart to JPG format.
 */
const exportToImage = (id, fileName) => {
  toJpeg(document.getElementById(id), { backgroundColor: '#FFF', quality: 0.95 }).then(url => {
    const link = document.createElement('a')

    link.download = `${fileName}.jpeg`
    link.href = url
    link.click()
  })
}

/**
 * Export a formatted array into CSV.
 */
export const exportToCsv = (data, fileName) => {
  const sheet = data.map(item => item.join(';')).join('\n')
  const link = document.createElement('a')
  const blob = new Blob([`\uFEFF${sheet}`], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  link.href = url
  link.setAttribute('download', `${fileName}.csv`)
  link.click()
}

export default exportToImage
